import { render, staticRenderFns } from "./ProductionInOutView.vue?vue&type=template&id=bb494cd6&scoped=true"
import script from "./ProductionInOutView.vue?vue&type=script&lang=js"
export * from "./ProductionInOutView.vue?vue&type=script&lang=js"
import style0 from "./ProductionInOutView.vue?vue&type=style&index=0&id=bb494cd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb494cd6",
  null
  
)

export default component.exports